document.addEventListener('DOMContentLoaded', function () {
  initCountdown();
  initFaqAccordion();
  initScrollToForm();
});

function initCountdown() {
  var el = document.getElementById('urgency-timer');
  if (!el) return;
  var total = 14 * 60 + 59;
  setInterval(function () {
    total -= 1;
    if (total < 0) total = 0;
    el.textContent = pad(Math.floor(total / 3600)) + ':' + pad(Math.floor((total % 3600) / 60)) + ':' + pad(total % 60);
  }, 1000);
}

function pad(n) {
  return n.toString().padStart(2, '0');
}

function initFaqAccordion() {
  document.querySelectorAll('.faq-question').forEach(function (q) {
    q.addEventListener('click', function () {
      var item = this.closest('.faq-item');
      if (!item) return;
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item.open').forEach(function (i) { i.classList.remove('open'); });
      if (!isOpen) item.classList.add('open');
    });
  });
}

function initScrollToForm() {
  document.querySelectorAll('[data-scroll-to-order]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var form = document.getElementById('order-form');
      if (form) form.scrollIntoView({ behavior: 'smooth' });
    });
  });
}
